export enum Hooks {
  NavigationRoot = '.js-navigation',
  NavigationMobileRoot = '.js-navigation-mobile',
  AnimatorRoot = '.js-animator',
  InViewRoot = '.js-inview',
  ShareBarRoot = '.js-share-bar',
  ParalaxRoot = '.js-paralax',
  CollectionSectionRoot = '.js-collection-section',
  SliderRoot = '.js-slider',
  AccordionRoot = '.js-accordion',
  SimpleAccordionRoot = '.js-simple-accordion',
  CutOutRoot = '.js-cutout',
  StickyProgressRoot = '.js-stickyprogress',
  ShareButtonRoot = '.js-share-button',
  SocialShareButtonRoot = '.js-social-share-button',
  VideoPlayerRoot = '.js-videoplayer',
  ExpanderRoot = '.js-expander',
  HighlightRoot = '.js-highlight',
  Dropdown = '.js-dropdown',
  FileInput = '.js-fileinput',
  Email = '.js-mail',
  UWorkMasterData = '.js-uwmd-dropdown',
  UWorkRoot = '.js-uwork',
  UWorkAutofill = '.js-uwork-autofill',
  UWorkForm = '.js-uwork-form',
  ModalRoot = '.js-modal',
  DatePickerRoot = '.js-datepicker',
  TruncateRoot = '[data-clamp]', // This way we can just specify how many lines should be visible
  TabsRoot = '.js-tabs',
  JobSearchRoot = '.js-job-search',
  JobFilterCountsRoot = '.js-job-filter-counts',
  FilterListRoot = '.js-filter-list',
  OpinionComparisonRoot = '.js-opinion-comparison',
  FavoriteVacancyButton = '.js-favorite-vacancy-button',
  CalendarSliderRoot = '.js-calendar-slider',
  FavoriteVacancyCounter = '.js-favorite-vacancy-counter',
  FavoriteVacanciesContainer = '.js-favorite-vacancies-container',
  FavoriteVacanciesTemplate = '.js-favorite-vacancy-template',
  VideoPlayerModal = '.js-video-player-modal',
  WorldMap = '.js-world-map',
  AnimateOnEntry = '.js-animate-on-entry',
  ImageSlider = '.js-image-slider',
  DownloadOrLinksExtended = '.js-downloads-or-links-extended',
  InvestmentSearchRoot = '.js-investment-search',
  InvestmentSearchDropdownRoot = '.js-investment-search-dropdown',
  Tooltip = '.js-tooltip',
  Testimonial = '.js-testimonial',
  ContentAccordion = '.js-content-accordion',
  Filter = '.js-filter',
  EmplyApplicationForm = '.js-emply-application-form',
  SrOnly = '.js-sr-only',
  VideoModalCloseButton = '.js-modal-close',
  FooterAccordion = '.footer__navigation-item--dropdown',
}
